import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Input from '../components/common/Input';
import Button from '../components/common/Button';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    const result = login(username, password);
    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.error);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 flex items-center justify-center px-4 sm:px-6">
      <div className="max-w-md w-full">
        <div className="text-center mb-6 sm:mb-8">
          <h1 className="text-3xl sm:text-4xl font-bold text-blue-500 mb-2">KOSPI200</h1>
          <p className="text-lg sm:text-xl text-gray-400">Auto Trading System</p>
        </div>

        <div className="bg-gray-800 rounded-lg shadow-2xl p-6 sm:p-8">
          {/* 테스트 계정 정보 */}
          <div className="mb-4 sm:mb-6 bg-blue-500/10 border border-blue-500/30 rounded-lg p-3 sm:p-4">
            <div className="flex items-center mb-2">
              <svg className="w-4 h-4 sm:w-5 sm:h-5 text-blue-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span className="text-xs sm:text-sm font-semibold text-blue-400">테스트 계정</span>
            </div>
            <div className="text-xs sm:text-sm text-gray-300 space-y-1">
              <div className="flex items-center">
                <span className="text-gray-500 w-16">아이디:</span>
                <span className="font-mono text-blue-300">demo</span>
              </div>
              <div className="flex items-center">
                <span className="text-gray-500 w-16">비밀번호:</span>
                <span className="font-mono text-blue-300">1234</span>
              </div>
              <p className="text-xs text-gray-500 mt-2">
                * Mock 시스템으로 모든 계정 정보로 로그인 가능합니다
              </p>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
            <Input
              label="아이디"
              type="text"
              placeholder="아이디를 입력하세요"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              error={error && !username ? '아이디를 입력해주세요' : ''}
            />

            <Input
              label="비밀번호"
              type="password"
              placeholder="비밀번호를 입력하세요"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              error={error && !password ? '비밀번호를 입력해주세요' : ''}
            />

            {error && (
              <div className="bg-red-500/10 border border-red-500 text-red-500 px-4 py-3 rounded-lg text-sm">
                {error}
              </div>
            )}

            <Button type="submit" variant="primary" className="w-full">
              로그인
            </Button>
          </form>

          <div className="mt-6 text-center">
            <a href="#" className="text-sm text-gray-500 hover:text-gray-400">
              비밀번호 찾기
            </a>
          </div>
        </div>

        <div className="mt-8 text-center text-sm text-gray-600">
          Version 1.0.0
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
